import { render } from "./BaseInputIVR.vue?vue&type=template&id=335ddea3&scoped=true"
import script from "./BaseInputIVR.vue?vue&type=script&lang=js"
export * from "./BaseInputIVR.vue?vue&type=script&lang=js"

import "./BaseInputIVR.vue?vue&type=style&index=0&id=335ddea3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335ddea3"]])

export default __exports__